import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {SaveItemAlertRequest} from "../api/dtos/dtos";
import {Form} from "antd";
import * as moment from 'moment';
import locales from "../locales";
import InputFormItem from "../common/form-items/InputFormItem";
import SubmitCancelFormItem from "../common/form-items/SubmitCancelFormItem";
import DatePickerFormItem from "../common/form-items/DatePickerFormItem";
import * as dateUtils from "../utils/date-utils";
import {MOMENT_DATE_FORMAT} from "../utils/date-utils";
import {notBlankValidator} from "../utils/form-utils";
import {numberGroupFormatter} from "../utils/number-utils";
import NumberFormItem from "../common/form-items/NumberFormItem";

const FIELD_NAME = 'name';
const FIELD_ALERT_DATE = 'alertDate';
const FIELD_HANDLED_DATE = 'handledDate';
const FIELD_OPERATION_HOURS = 'operationHours';

interface Props extends FormComponentProps {
  alert: SaveItemAlertRequest;
  onFormSubmit: (alert: SaveItemAlertRequest) => void;
  onFormCancel: () => void;
}

class ItemAlertForm extends React.Component<Props, {}> {

  public render() {
    const {form, alert} = this.props;
    const alertDate = (alert && alert.alertDate) ? dateUtils.toMomentOrThrow(alert.alertDate) : moment();
    const handledDate = (alert && alert.handledDate) ? dateUtils.toMomentOrThrow(alert.handledDate) : null;
    const operationHours = alert.operationHours;

    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_NAME}
          label={locales.appellation}
          initialValue={alert.name}
          required={true}
          rules={[{
            message: locales.cant_be_empty,
            validator: (rule, value, callback) => notBlankValidator(value, callback),
          }]}
        />
        <DatePickerFormItem
          form={form}
          fieldId={FIELD_ALERT_DATE}
          label={locales.alert_date}
          initialValue={alertDate}
          required={true}
          showTime={false}
          format={MOMENT_DATE_FORMAT}
        />
        <DatePickerFormItem
          form={form}
          fieldId={FIELD_HANDLED_DATE}
          label={locales.alert_handled_date}
          initialValue={handledDate}
          required={false}
          showTime={false}
          format={MOMENT_DATE_FORMAT}
        />
        <NumberFormItem
          label={locales.operation_hours_reading}
          fieldId={FIELD_OPERATION_HOURS}
          form={form}
          initialValue={operationHours}
          required={false}
          min={0}
          step={0.1}
          precision={1}
          formatter={numberGroupFormatter}
        >
          <> {locales.hours}</>
        </NumberFormItem>
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {alert, form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit({
          ...alert,
          name: values[FIELD_NAME],
          alertDate: values[FIELD_ALERT_DATE],
          handledDate: values[FIELD_HANDLED_DATE],
          operationHours: values[FIELD_OPERATION_HOURS]
        });
      }
    });
  };
}

export default Form.create<Props>()(ItemAlertForm);



// WEBPACK FOOTER //
// ./src/alerts/ItemAlertForm.tsx